"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarbreakerAbilityHandler = exports.StarbreakerActorAbilityFactory = exports.StarbreakerAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const TimeInterval_1 = require("../../core/vfx/TimeInterval");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class StarbreakerAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Starbreaker;
        this.__typeName = "Starbreaker";
    }
}
exports.StarbreakerAbilityArgs = StarbreakerAbilityArgs;
let StarbreakerActorAbilityFactory = class StarbreakerActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Starbreaker", "Self", 8);
    }
};
StarbreakerActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Starbreaker")
], StarbreakerActorAbilityFactory);
exports.StarbreakerActorAbilityFactory = StarbreakerActorAbilityFactory;
let StarbreakerAbilityHandler = class StarbreakerAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const { applyCameraVfx, resetCameraVfx } = core_1.CameraVfxStepArgs.mkSequencesFor(
        // CameraVfxStepArgs.Alpha(.2),
        // CameraVfxStepArgs.Zoom(.4),
        );
        container.applyAbilityAnimation({
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            delay: new core_1.DelayVfxStepArgs(new TimeInterval_1.PercentAnimationDurationVfxTimeInterval(ability.invokerId, 1)),
            sequence: sequence.push(applyCameraVfx.mk()),
            onAnimated(sequence) {
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    effect: new core_2.LinkedEffectsEffectArgs([
                        new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamagePercentIncrease, 100),
                        new core_2.LinkedEventHandlerEffectArgs("Starbreaker", "Burning light and Darkness on hit.", false, container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttack", {
                            applyTo: "attacked",
                            onHitOnly: true,
                            effects: [
                                {
                                    duration: Duration_1.Duration.Turns(4),
                                    effect: new core_2.LinkedEffectsEffectArgs([
                                        new core_2.BurningLightEffectArgs("Power", 10),
                                        new core_2.DarknessEffectArgs()
                                    ], true)
                                }
                            ]
                        }))
                    ], false),
                    duration: Duration_1.Duration.Turns(8),
                    sequence: sequence.pushSequence("sequential"),
                });
                sequence.push(resetCameraVfx.mk());
            }
        });
    }
};
StarbreakerAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Starbreaker)
], StarbreakerAbilityHandler);
exports.StarbreakerAbilityHandler = StarbreakerAbilityHandler;
